import React, { useContext } from 'react';

import { LocationContext } from '../contexts/LocationContext';
import { buildServiceSchema, JsonLd } from '../utils/structuredData';

interface ServiceStructuredDataProps {
  name: string;
  description?: string;
  imageUrl?: string;
}

function ServiceStructuredData({
  name,
  description,
  imageUrl,
}: ServiceStructuredDataProps): React.ReactElement {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const location = useContext(LocationContext)!;

  return (
    <JsonLd
      data={buildServiceSchema({
        name,
        description,
        imageUrl,
        pathname: location.pathname,
      })}
    />
  );
}

export default ServiceStructuredData;
